<style lang="stylus">
.thank-you-header {
	font-size: 56px;
	font-weight: 900;
	margin-bottom: 17px;
	color: #191919;
}

.thank-you-sub-header {
	font-size: 30px;
	font-weight: 500;
	margin-bottom: 32px;
}

.thank-you-contact-icon {
	margin-top: 12px;
}

.thank-you-content {
	margin-bottom: 32px;
	max-width: 673px;
	font-weight: 400;
	font-size: 18px;
}

.thank-you-button {
	margin-bottom: 80.5px;
	margin-left: -8px;
}

@media (max-width: 600px) {
	.thank-you-contact-icon {
		margin: 0 0 24px 32px;
	}

	.thank-you-header {
		font-size: 36px;
		margin: 0 0 16px 32px;
	}

	.thank-you-sub-header {
		font-size: 18px;
		margin: 0 31px 31.6px 32px;
	}

	.thank-you-content {
		font-size: 16px;
		margin: 0 33px 32.5px 32px;
	}

	.thank-you-button {
		margin-bottom: 58.5px;
		margin-left: 24px;

		button {
			width: 275.7px;
			height: 45px;
		}

		span {
			font-size: 16px;
			padding-right: 11.7px;
		}
	}
}
</style>
<template>
  <div>
    <v-container class="container">
      <v-row wrap>
        <v-col cols="12" lg="3" md="4" sm="4" class="thank-you-contact-icon" style="text-align: center">
          <img class="d-none d-sm-flex" src="../assets/images/contact-icon.svg" />
          <img class="d-flex d-sm-none" width="125.5px" height="80px" src="../assets/images/contact-icon.svg" />
        </v-col>
        <v-col cols="8" md="8" sm="8">
          <div class="thank-you-header">Thank you.</div>
          <div class="thank-you-sub-header">Your identity verification is in progress.</div>
          <div class="thank-you-content">
            We have received your information and are verifying your identity. You will see a message on your dashboard
            when the verification process is complete (usually within 1-2 days). In the meantime, you can still access
            all available course content.
          </div>
          <div class="nextButton thank-you-button">
            <v-btn
              @click="
                asuoDataLayerClick('idVerifiyThankYou', '0', {});
                goToDashboard();
              "
              :ripple="false"
              variant="flat"
            >
              <span style="padding-left: 6px">Return to your dashboard</span>
              <v-icon left style="margin-right: 0">mdi-arrow-right</v-icon>
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import { defineComponent } from 'vue';
import { useViewAsStore } from '@/stores/viewAs';

import { DataLayerMixin } from '../mixins/dataLayerMixin.js';
import { AjaxLoader } from '../mixins/ajaxLoader';

export default defineComponent({
  mixins: [DataLayerMixin, AjaxLoader],

  methods: {
    async goToDashboard() {
      // getUserId() is always the real admin, not whoever is being viewed as.
      const viewAsStore = useViewAsStore();
      if (!viewAsStore.isActive && !viewAsStore.hasPendingSession) {
        let self = this;
        await this.$conn
          .getLearnerDetails(this.$auth.getUserId())
          .then()
          .finally(() => self.clearLoader());
      }

      this.$router.push({ name: 'dashboard' });
    }
  }
});
</script>
